import React, { useState } from "react";
import "./AppSidebar.css";
import Accordion from "react-bootstrap/Accordion";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, useLocation, useNavigate } from "react-router-dom";
import navigation from "../../_nav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

const AppSidebar = ({ closeSidebar = () => {} }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);

  const isActive = (path) => {
    if (!path) return false;
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  const handleClose = () => {
    setShowSidebar(false);
    closeSidebar();
  };

  const handleNavigate = (path) => {
    handleClose();
    navigate(path);
  };

  const sidebarContent = (
    <>
      <div className="logo_div">
        <Link to="/dashboard" className="brand_name" onClick={handleClose}>
          LensMartin
        </Link>
      </div>

      <div className="sidebar_list">
        {/* Top-Level Accordion for Groups (OPERATIONS, PEOPLES, etc.) */}
        <Accordion
          flush
          defaultActiveKey={navigation?.map((_, idx) => `group-${idx}`)}
          alwaysOpen
        >
          {navigation?.map((group, groupIndex) => (
            <Accordion.Item
              eventKey={`group-${groupIndex}`}
              key={groupIndex}
              className="group_accordion_item"
            >
              {/* Collapsible Category Header */}
              {group.title && (
                <Accordion.Header className="group_header">
                  <span className="yellow_bar"></span>
                  <span className="section_title">{group.title}</span>
                </Accordion.Header>
              )}

              {/* Category Body Containing Items */}
              <Accordion.Body className="group_body">
                {/* Nested Accordion for Inner Items (e.g., Orders) */}
                <Accordion flush>
                  {group.items?.map((item, index) => {
                    const isParent =
                      Array.isArray(item.items) && item.items.length > 0;
                    const itemKey = `sub-${groupIndex}-${index}`;

                    if (isParent) {
                      return (
                        <Accordion.Item
                          eventKey={itemKey}
                          key={index}
                          className="parent_item"
                        >
                          <Accordion.Header
                            className={isActive(item.to) ? "active_header" : ""}
                          >
                            <img src={item.img} alt="" className="icon_img" />
                            <span>{item.name}</span>
                          </Accordion.Header>

                          <Accordion.Body>
                            <div className="acc_inner_menu">
                              {item.items.map((subItem, subIndex) => {
                                const subActive = isActive(subItem.to);

                                return (
                                  <div
                                    key={subIndex}
                                    className={`sub_menu_item ${
                                      subActive ? "active" : ""
                                    }`}
                                    onClick={() => handleNavigate(subItem.to)}
                                  >
                                    <span className="tree_dot"></span>

                                    <span className="sub_menu_text">
                                      {subItem.name}
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    }

                    // Single Navigation Item
                    const active = isActive(item.to);

                    return (
                      <div
                        key={index}
                        className={`single_nav_item ${
                          active ? "active_pill" : ""
                        }`}
                        onClick={() => handleNavigate(item.to)}
                      >
                        <img src={item.img} alt="" className="icon_img" />
                        <span>{item.name}</span>
                      </div>
                    );
                  })}
                </Accordion>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>

      <div
        className="footer_div"
        onClick={() => handleNavigate("/lensmartin-store")}
      >
        <div className="left_img_holder">
          <img
            src="/assets/images/sidebar/sidebarfooter.png"
            className="innerimg"
            alt=""
          />
        </div>

        <div className="text_holder">
          <p className="upper_text">Lensmartin Store, Bavdhan, Pune</p>
        </div>

        <div className="arrow_div">
          <FontAwesomeIcon icon={faAngleRight} className="arrow_txt" />
        </div>
      </div>
    </>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="sidebar_main desktop_sidebar">{sidebarContent}</aside>

      {/* Mobile Sidebar */}
      <div className="mobile_sidebar_wrapper">
        <button
          type="button"
          className="mobile_sidebar_toggle"
          onClick={() => setShowSidebar(true)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <Offcanvas
          show={showSidebar}
          onHide={handleClose}
          placement="start"
          className="mobile_sidebar_offcanvas"
        >
          <Offcanvas.Body className="mobile_sidebar_body">
            <aside className="sidebar_main mobile_sidebar">
              {sidebarContent}
            </aside>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default AppSidebar;
